export default {aggregate:"com.armus.product:hybrid-accsts-jsclient:2025.10.13:20251013-1833",
    client: "com.armus:hybrid-jsclient:2025.09.30:20250930-2241",
    requiredApiVersion: "1.86.0",
};



// WEBPACK FOOTER //
// ./app/version.js